export default "__VITE_ASSET__Dj4L1z9T__"